import React, { useEffect, useState } from 'react';
import { useLoginMutation, useMeQuery } from '../../generated/graphql';

import { CenterScreenComponent } from '../../components';
import OAuthService from '../../services/OauthService';
import { Spinner } from 'react-bootstrap';
import { createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { useHistory } from 'react-router-dom';
import { useQuery } from '../../hooks';
import { useTranslation } from 'react-i18next';

interface AuthenticationScreenProps {}

export const AuthenticationScreen: React.FC<AuthenticationScreenProps> = () => {
    const [t] = useTranslation();
    const [error, setError] = useState<null | string>(null);
    const [login, { loading }] = useLoginMutation();
    const { refetch, client } = useMeQuery();
    const history = useHistory();
    const query = useQuery();
    const code = query.get('code') || '';

    useEffect(() => {
        async function componentDidMount() {
            try {
                const { data, context } = await login({
                    variables: {
                        code: code,
                        isMobile: false,
                        redirectUri: OAuthService.redirectUri(),
                        code_verifier: '',
                    },
                });
                const token = data?.login;
                localStorage.setItem('token', token || '');

                // Reset Apollo client completely

                const httpLink = createHttpLink({
                    uri: `${process.env.REACT_APP_SERVER}/graphql`,
                });
                const authLink = setContext((_, { headers }) => {
                    return {
                        headers: {
                            ...headers,
                            authorization: token ? token : '',
                        },
                    };
                });
                client.setLink(authLink.concat(httpLink));

                await refetch();

                // Small delay to ensure data is loaded
                await new Promise((resolve) => setTimeout(resolve, 100));

                const returnUrl = localStorage.getItem('returnUrl') || '/';
                localStorage.removeItem('returnUrl');
                history.replace(returnUrl);
                await refetch();
            } catch (error) {
                console.log(error);
                setError('error');
            }
        }
        componentDidMount();
    }, [code, history, login, refetch, client]);

    if (error) {
        return (
            <CenterScreenComponent>
                <div>{t('authorization.error')}</div>
                <div>{t('authorization.error.try_again')}</div>
            </CenterScreenComponent>
        );
    }

    if (loading) {
        return (
            <CenterScreenComponent>
                <div>{t('authorization.progress')}</div>
                <Spinner animation="border" />
            </CenterScreenComponent>
        );
    }

    return (
        <CenterScreenComponent>
            <div>{t('authorization.success')}</div>
        </CenterScreenComponent>
    );
};
